








































































































































































































































































































































































































































































































































































import VueOptions from '@utils/VueOptions'
import Editor from '@components/Editor'
import Upload from '@components/Upload'
import Modal from '@components/Modal'
import PromptModal from '@components/PromptModal'
import RequestButton from '@/components/RequestButton'
import EventTaskList from '@components/EventTaskList'
import RecessAPI from '@services/RecessAPI'

import HostNativeIntegrationEditor from './editors/HostNativeIntegrationEditor'
import SuperNativeIntegrationEditor from './editors/SuperNativeIntegrationEditor'
import HostBoothEditor from './editors/HostBoothEditor'
import SuperBoothEditor from './editors/SuperBoothEditor'
import HostTruckEditor from './editors/HostTruckEditor'
import SuperTruckEditor from './editors/SuperTruckEditor'
import HostMediaEditor from './editors/HostMediaEditor'
import SuperMediaEditor from './editors/SuperMediaEditor'
import HostSocialPostEditor from './editors/HostSocialPostEditor'
import SuperSocialPostEditor from './editors/SuperSocialPostEditor'
import HostProductSamplingEditor from './editors/HostProductSamplingEditor'
import SuperProductSamplingEditor from './editors/SuperProductSamplingEditor'

import EventSponsorSet from './EventSponsorSet'

statesByKey = require('@assets/states.json')

settings =
  name: ""
  vue:
    props: [
      'eventWizard',
      'options',
      'context',
      'show',
      'actions',
      'nativeIntegrationEditor',
      'boothEditor',
      'truckEditor',
      'mediaEditor',
      'productSamplingEditor',
      'socialPostEditor',
      'page',
    ]
    store: ['marketplace']
    components: {
      Editor,
      EventTaskList,
      Upload,
      HostNativeIntegrationEditor,
      SuperNativeIntegrationEditor,
      HostBoothEditor,
      SuperBoothEditor,
      HostTruckEditor,
      SuperTruckEditor,
      HostMediaEditor,
      SuperMediaEditor,
      HostProductSamplingEditor,
      SuperProductSamplingEditor,
      HostSocialPostEditor,
      SuperSocialPostEditor,
      RequestButton,
      PromptModal,
      Modal,
      EventSponsorSet,
    }
    data: ->
      canPlayMedia: false
      addingOrganizer: false
      newOrganizer: {}
      fileList: []
      confirmTime: null
      difficulty: null
      feedback: null
      role: null
      bestContact: null
      plansToTransition: null
      selectedOrg: null
      yearsRunning: null
      confirmed: null
      date: new Date()
      venueState: null
      timezone: null
      virtualSpaces: []
      boothSpaces: []
      mediaSpaces: []
      truckSpaces: []
      productSamplingSpace: null
      socialPostSpace: null
      nativeIntegrationSpace: null
      hasVirtualSpaces: true
      hasProductSamplingSpaces: true
      hasSocialPostSpaces: true
      hasNativeIntegrationSpace: true
      hasBoothSpaces: true
      hasMediaSpaces: false
      hasTruckSpaces: true
      hasStorage: false
      schedule:
        startDay: null
        endDay: null
        startTime: '08:00 AM'
        endTime: '06:00 PM'
      restrictions:
        drinks: []
        food: []
      sponsorPrefs:
        banned: null
        confirmed: null
        past: null
        preferred: null
      totalPages: 13
      geoSearching: false
      showAddOrganizer: false
      showSelectContactModal: false
      showSelectAdvisorModal: false
      frozenEvent: null
      showEnhancementModal: false
      confirmContactModal:
        show: false
        title: ''
        button:
          label: ''
          handler: null
      maskedReach: ''
      organizerAdditionalTOS: ''
    computed:
      actionsForSponsorSet: ->
        {
          addSponsorSetTrigger: @actions.addSponsorSetTrigger,
          removeSponsorSetTrigger: @actions.removeSponsorSetTrigger,
          markSponsorSetAsPrimary: @actions.markSponsorSetAsPrimary,
          unmarkSponsorSetAsPrimary: @actions.unmarkSponsorSetAsPrimary,
        }

      virtualSettingSelected: -> "virtual" is @eventWizard.venue?.location?.setting

      listingClasses: ->
        data = @marketplace?.listing?.classes
        order = @marketplace.listing?.promoted?.classes
        @hashToElementUIOptions data, order
      listingTypes: ->
        data = @marketplace?.listing?.types
        order = @marketplace.listing?.promoted?.types
        @hashToElementUIOptions data, order
      listingCategories: ->
        data = @marketplace?.listing?.categories
        order = @marketplace.listing?.promoted?.categories
        @hashToElementUIOptions data, order

      canProceed: -> @page < @totalPages
      canPublish: -> @eventWizard.missing_required_fields.length is 0 && !@eventWizard.published
      changesHaveBeenMade: -> !@objectsAreEqual(@frozenEvent, @eventWizard)
      eventHasAdvisor: -> @eventWizard.organizers.find (o) -> o.role is 'Advisor'
      eventHasContactForSponsorships: -> @eventWizard.organizers.find (o) -> o.contact_for_sponsorships is true
      selectedOrganizationIsNew: -> @selectedOrg and !(@options.organizations.map (o) -> o.id).includes @selectedOrg
      step: -> 
        return 3 if @page is 16
        return 2 if @page > 9
        if not @eventWizard.physical_event
          return 5 if @page is 6 or @page is 7
          return 10 if @page is 11 or @page is 12
        1
      showNextButton: -> 
        return false if @page is 9
        return @page < @totalPages
      states: -> statesByKey
      mapOptions: ->
        zoomControl: true
        mapTypeControl: false
        scaleControl: false
        streetViewControl: false
        rotateControl: false
        fullscreenControl: false
        disableDefaultUi: true
      runningSinceOptions: ->
        opts = []
        currentYear = parseInt(new Date().getFullYear())
        opts.push { label: "#{currentYear - parseInt(k)}" , value: "#{currentYear - parseInt(k)}"} for k in [0..10]
        opts.push { label: "Before #{currentYear - 10}", value: "#{currentYear - 11 }" }
        opts[0].label = "First Time"
        opts
      markerPosition: ->
        return { lat: @eventWizard.venue.location.lat, lng: @eventWizard.venue.location.lng } if @eventWizard.venue.location.lat?
        { lat: 0, lng: 0 }
      routePageForField: ->
        name: 1
        description: 1
        live_stream: 1
        physical_event: 1
        streaming_platforms: 1
        types: 1
        starts_at: 2
        ends_at: 2
        viewers: 3
        reach: 3
        venue_name: 4
        venue_street: 4
        venue_city: 4
        venue_state: 4
        venue_zip: 4
        space: 5
        photos: 10
        website: 10
        schedule_confirmed: 2
        sales_prohibited: 11
        can_collect_student_data: 11
        food_can_be_distributed: 11
        drink_can_be_distributed: 11
      showNativeIntegrationSelector: -> 
        show = @hasNativeIntegrationSpace
        (show ||= space.selected and space.type is "native_integration") for space in @virtualSpaces
        show
      showBoothSelector: -> 
        show = @hasBoothSpaces
        show ||= space.selected for space in @boothSpaces
        show
      showMediaSelector: -> 
        show = @hasMediaSpaces
        show ||= space.selected for space in @mediaSpaces
        show
      showTruckSelector: -> 
        show = @hasTruckSpaces
        show ||= space.selected for space in @truckSpaces
        show
      endDayOptions: -> { disabledDate: @endDateIsInvalid }
      startDayOptions: -> { disabledDate: @startDateIsInvalid }
      beginYearOptions: -> { disabledDate: @beginYearIsInvalid }
      shouldShowProgressEnhancements: -> @eventWizard.listed || @eventWizard.recess_verified || @page > 9
    methods:
      bestContactPrototype: -> JSON.parse(JSON.stringify(@eventWizard.organizer_prototype))
      bestContactChanged: (value) ->
        @newOrganizer = (@eventWizard.organizers.filter (o) -> o.current_organizer)[0] if value is 'me'
        @newOrganizer = @bestContactPrototype() unless value is 'me'
        @newOrganizer.role = 'Advisor' if value is 'advisor'
        @newOrganizer.contact_for_sponsorships = true
        @plansToTransition = true if @newOrganizer.transfer_account_at?
        @rerender()
      organizerCollapseClassForOrganizer: (organizer) ->
        # return 'bg-recess text-white' if organizer.contact_for_sponsorships
        return 'bg-white text-grey-dark'
      addNewAdvisor:->
        @newOrganizer.role = 'Advisor'
        @showAddOrganizerModal()
      addNewContactForSponsorships:->
        @newOrganizer.contact_for_sponsorships = true
        @showAddOrganizerModal()
      showAddOrganizerModal: () ->  
        @closeSelectAdvisorModal()
        @showAddOrganizer = true
      organizerIsContactForSponsorships: (organizer) -> organizer.contact_for_sponsorships is true
      organizerSelectedAsContactForSponsorships: (organizer) ->  
        if organizer.contact_for_sponsorships
          @actions.resetOrganizerAsContactForSponsorships(organizer.id)
        else 
          @actions.setOrganizerAsContactForSponsorships(organizer.id)
      saveAdvisorModal: -> 

      beginYearIsInvalid: (time) -> time.getFullYear() > (new Date(@schedule.startDay)).getFullYear()
      endDateIsInvalid: (time) -> time.getTime() < (new Date(@schedule.startDay)).getTime()
      startDateIsInvalid: (time) -> time.getTime() < Date.now() - 8.64e7
      handleStartDayChanged: (value) -> @schedule.endDay = value unless @schedule.endDay?
      handleStartTimeChanged: (value) -> @schedule.endTime = value unless @schedule.endTime?
      hiOrgSelected: (organization) ->
        if @selectedOrganizationIsNew
          @eventWizard.supplier_sub_organization.name = organization
          @eventWizard.supplier_sub_organization.id = null
          @eventWizard.supplier_sub_organization.website = null
        else
          @eventWizard.supplier_sub_organization.id = organization
          @eventWizard.supplier_sub_organization.name = null
      imageForSpace: (space) -> "#{process.env.VUE_APP_IMAGE_ENDPOINT}/spaces/#{space.type}.png"
      hiPublish: -> 
        return @showAlert('The end time for your event must be after the start time.', 'Validation Alert') unless @validateEndTimeIsAfterStartTime()
        @actions.publish(@page) if @canPublish
      handlePublishAndContinue: ->
        return @showAlert('The end time for your event must be after the start time.', 'Validation Alert') unless @validateEndTimeIsAfterStartTime()
        @actions.publish(@page + 1) if @canPublish
      handleStartEnhancingButtonClicked: -> 
        @showEnhancementModal = false
        @$parent.setPage(10)
      selectSpace: (space) -> 
        space.selected = !space.selected
        if space.selected 
          @spaceUpdated(space)
        else
          @spaceDeleted(space)
      selectBoothSpace: (space) -> 
        @selectSpace(space)
        # if no booth spaces are selected, set hasBoothSpaces to false
      selectMediaSpace: (space) -> 
        @hasMediaSpaces = !@hasMediaSpaces
        @canPlayMedia = true if @hasMediaSpaces and !@canPlayMedia
      selectTruckSpace: (space) -> 
        @selectSpace(space)

      spaceAdded: -> Object.keys(@eventWizard?.spaces || {}).length
      spaceDeleted: (space) -> delete @eventWizard.spaces[space.name]
      spaceUpdated: (space) -> @eventWizard.spaces[space.name] = space
      dayTimewindow: (start_date, start_time, end_time)->
        all_day = false
        reach = 1 # +++
        {start_date, start_time, end_time, all_day, reach}

      eventDays: ()->
        days = []
        return days unless @schedule.startDay?
        @schedule.endDay = @schedule.startDay unless @schedule.endDay?
        startDay = dayjs(dayjs(@schedule.startDay).format('YYYY-MM-DD'))
        endDay = dayjs(dayjs(@schedule.endDay).format('YYYY-MM-DD'))
        day = startDay
        days.push day.format('YYYY-MM-DD')

        while day.isBefore(endDay)
          day = day.add(1, "day")
          days.push day.format('YYYY-MM-DD')
        days

      generateSchedule: ()->
        # assume start and end time are the same for multi-day events -- for now
        schedule = []
        days = @eventDays()
        for day in days
          timewindow = @dayTimewindow day, @schedule.startTime, @schedule.endTime
          schedule.push timewindow
        schedule

      markerDragged: () ->
        if !@geoSearching
          marker = @$refs.marker 
          coordinates = { lat: marker.$markerObject.position.lat() , lng: marker.$markerObject.position.lng() }
          @geoSearching = true
          location = await RecessAPI.getGeoLocation(coordinates)
          if location?.address_components?[0]?
            streetNumber = (c for c in location.address_components when c.types.includes('street_number'))[0].long_name
            streetName = (c for c in location.address_components when c.types.includes('route'))[0].long_name
            city = (c for c in location.address_components when c.types.includes('locality'))[0].long_name
            state = (c for c in location.address_components when c.types.includes('administrative_area_level_1'))[0].short_name
            postalCode = (c for c in location.address_components when c.types.includes('postal_code'))[0].long_name
            @eventWizard.venue.location.lat = coordinates.lat
            @eventWizard.venue.location.lng = coordinates.lng
            @eventWizard.venue.location.street = "#{streetNumber} #{streetName}"
            @eventWizard.venue.location.zip = postalCode
            @eventWizard.venue.location.city = city
            @eventWizard.venue.location.state = state
            @geoSearching = false
            @rerender()
          else 
            @geoSearching = false
      venueLocationChanged: () ->
        if !@geoSearching
          location = "#{@eventWizard.venue.location.street} #{@eventWizard.venue.location.city}"
          @geoSearching = true
          coords = await RecessAPI.getGeoCoordinates(location)
          if coords
            @eventWizard.venue.location.lat = coords.lat
            @eventWizard.venue.location.lng = coords.lng
            @geoSearching = false
            @rerender()
          else 
            @geoSearching = false
      backClicked: ->
        pageDecrement = 1
        if @page is 5 and not @eventWizard.physical_event
          pageDecrement = 2
        if @page is 8 and not @eventWizard.physical_event
          pageDecrement = 3
        if @page is 13
          pageDecrement = 3 unless @eventWizard.physical_event
        @saveWizard(@page - pageDecrement)
      nextClicked: ->
        if @page < @totalPages
          pageIncrement = 1
          if @page is 1
            if not @eventWizard.physical_event and not @eventWizard.live_stream
              return @showAlert('Please indicate wether the attendees will experience the event in person, over a live stream or both', 'In Person and/or Live Stream?')
          if @page is 2 
            return @showAlert('The end time for your event must be after the start time.', 'Validation Alert') unless @validateEndTimeIsAfterStartTime()
            if not @eventWizard.physical_event and not @eventWizard.live_stream
              return @showAlert('Please go back and indicate wether the attendees will experience the event in person, over a live stream or both', 'In Person and/or Live Stream?')
          if @page is 3 and not @eventWizard.physical_event
            pageIncrement = 2
          if @page is 5 and not @eventWizard.physical_event
            pageIncrement = 3
          if @page is 8 
            shouldPause = @promptToAddContacts()
            if shouldPause
              return
          if @page is 10
            pageIncrement = 3 unless @eventWizard.physical_event
          @saveWizard(@page + pageIncrement)
        else 
          @saveAndExit()
      navigateToField: (field) -> @saveWizard(@routePageForField[field])
      page2BeforeSave: ->
        @eventWizard.new_schedule = @generateSchedule()
      page3BeforeSave: ->
        @eventWizard.reach = parseInt("#{@maskedReach}".replace(/,/g, '') || 0)
      page12BeforeSave: ->
        prefs = @eventWizard.sponsor_preferences
        prefs.banned = @listFromText @sponsorPrefs.banned
        prefs.confirmed = @listFromText @sponsorPrefs.confirmed
        prefs.past = @listFromText @sponsorPrefs.past
        prefs.preferred = @listFromText @sponsorPrefs.preferred
      page13BeforeSave: ->
        @eventWizard.misc =
          form_feedback: @feedback
          form_difficulty: @difficulty
      addNewOrganizerFromModal: -> 
        @actions.addTeamMember(@newOrganizer)
      promptToAddContacts: -> 
        @showSelectContactModal = true if !@eventHasContactForSponsorships
        @showSelectAdvisorModal = true if @eventHasContactForSponsorships and !@eventHasAdvisor
        return @showSelectAdvisorModal || @showSelectContactModal
      closeAndResetMemberModal: -> 
        @showAddOrganizer = false
        @newOrganizer = @bestContactPrototype()
      closeConfirmContactModal: -> @confirmContactModal.show = false
      closeSelectContactForSponsorshipsModal: (proceed) -> 
        @showSelectContactModal = false
        @$parent.setPage(@page + 1) if proceed
      closeSelectAdvisorModal: (proceed) -> 
        @showSelectAdvisorModal = false
        @$parent.setPage(@page + 1) if proceed
      saveWizard: (anticipatedPage) -> 
        @["page#{@page}BeforeSave"]?()
        @actions.saveWizard(anticipatedPage, @changesHaveBeenMade)
      closeWizard: -> @$parent.closeWizard()
      saveAndExit: ->
        if !@validateEndTimeIsAfterStartTime()
          return @showAlert('The end time for your event must be after the start time.', 'Validation Alert')
        else 
          @saveWizard(-1)
      initializeSpaces: (category) ->
        spaces = @options.spaces.filter (s) -> s.category is category
        for space in spaces
          if @eventWizard.spaces[space.name]?
            space.selected = true
            space[k] = v for k,v of @eventWizard.spaces[space.name]
          else 
            space.selected = false
        spaces
      initializeWizard: ->
        @selectedOrg = @eventWizard.supplier_sub_organization?.id
        if !@eventWizard.timezone?
          offsetTable = @options.timezone_table_for_utc_offsets_in_hours
          hourTimezoneOffset = (new Date()).getTimezoneOffset() / 60
          @eventWizard.timezone = offsetTable[@options.daylight_savings_mode][hourTimezoneOffset] 
          @eventWizard.timezone ||= 'pacific'
        @newOrganizer = @bestContactPrototype()
        @schedule =
          startDay: @stringDayToDayJS(@eventWizard.local_start_day)
          endDay: @stringDayToDayJS(@eventWizard.local_end_day)
          startTime: @eventWizard.local_start_time
          endTime: @eventWizard.local_end_time

        prefs = @eventWizard.sponsor_preferences || {}
        prefs.banned ||= []
        prefs.confirmed ||= []
        prefs.past ||= []
        prefs.preferred ||= []
        @sponsorPrefs.banned = prefs.banned.join('\n')
        @sponsorPrefs.confirmed = prefs.confirmed.join('\n')
        @sponsorPrefs.past = prefs.past.join('\n')
        @sponsorPrefs.preferred = prefs.preferred.join('\n')
        @virtualSpaces = @initializeSpaces 'virtual'
        @nativeIntegrationSpace = @virtualSpaces.find (space)-> "native_integration" is space.type

        @samplingSpaces = @initializeSpaces 'sampling'
        @productSamplingSpace = @samplingSpaces.find (space)-> "product_sampling" is space.type
        @socialPostSpace = @virtualSpaces.find (space)-> "social_media_post" is space.type
        @boothSpaces = @initializeSpaces 'booth'
        @mediaSpaces = @initializeSpaces 'media'
        @truckSpaces = @initializeSpaces 'truck'

        #prepopulate sampling
        @productSamplingSpace?.selected = true if not @spaceAdded()
        @spaceUpdated(@productSamplingSpace)

        @hasVirtualSpaces ||= space.selected for space in @virtualSpaces
        @hasProductSamplingSpaces = @productSamplingSpace?.selected
        @hasSocialPostSpaces = @socialPostSpace?.selected
        @hasNativeIntegrationSpace ||= (space.selected and space.type is "native_integration") for space in @virtualSpaces
        @hasBoothSpaces ||= space.selected for space in @boothSpaces
        @hasMediaSpaces ||= space.selected for space in @mediaSpaces
        @hasTruckSpaces ||= space.selected for space in @truckSpaces
        @canPlayMedia ||= space.selected for space in @mediaSpaces
        @difficulty = @eventWizard.misc.form_difficulty if @eventWizard.misc?.form_difficulty?
        @feedback = @eventWizard.misc.form_feedback if @eventWizard.misc?.form_feedback?
        @maskedReach = @eventWizard.reach if @eventWizard?.reach
        @hasStorage = @hasStorageSelected()
      hasStorageSelected: ->
        storageKeys = [
          'storage_available',
          # 'storage_out_of_sunlight_available',
          'climate_controlled_storage_available',
          'cold_storage_available',
          'frozen_storage_available',
        ]
        return true for key in storageKeys when @isTruthy @eventWizard.restrictions.onsite[key]
        false
      hiHasStorage: ->
        return if @hasStorage
        storageKeys = [
          'storage_available',
          # 'storage_out_of_sunlight_available',
          'climate_controlled_storage_available',
          'cold_storage_available',
          'frozen_storage_available',
        ]
        @eventWizard.restrictions.onsite[key] = false for key in storageKeys

      scheduleIdByTime: (time) -> @options.day_times.findIndex (t) -> t.id is time
      validateEndTimeIsAfterStartTime: ->
        return true unless @schedule.startTime? and @schedule.endTime?
        return true unless @schedule.startDay? and @schedule.endDay?
        return true if !dayjs(@schedule.startDay).isSame(@schedule.endDay, 'day')
        return @scheduleIdByTime(@schedule.endTime) > @scheduleIdByTime(@schedule.startTime)
      showConfirmBestContactModal: (organizer) -> 
        organizerName = "#{organizer.first_name} #{organizer.last_name}"
        if organizer.contact_for_sponsorships
          handler = () => @actions.resetOrganizerAsContactForSponsorships(organizer.id)
          title = "Would you like to remove #{organizerName} as a best contact for this event?" 
        else 
          handler = () => @actions.setOrganizerAsContactForSponsorships(organizer.id)
          title = "Would you like to make #{organizerName} a best contact for this event?"
        show = true
        button = { label: 'Yes', handler }
        @confirmContactModal = { title, show, handler, button }
      updateWizard: -> 
        @virtualSpaces = @initializeSpaces 'virtual'
        @samplingSpaces = @initializeSpaces 'sampling'
        @productSamplingSpace = @samplingSpaces.find (space)-> "product_sampling" is space.type
        @socialPostSpace = @virtualSpaces.find (space)-> "social_media_post" is space.type
        @nativeIntegrationSpace = @virtualSpaces.find (space)-> "native_integration" is space.type
        @boothSpaces = @initializeSpaces 'booth'
        @mediaSpaces = @initializeSpaces 'media'
        @truckSpaces = @initializeSpaces 'truck'

        #prepopulate sampling
        @productSamplingSpace?.selected = true if not @spaceAdded()
        @spaceUpdated(@productSamplingSpace)

        @hasVirtualSpaces ||= space.selected for space in @virtualSpaces
        @hasProductSamplingSpaces = @productSamplingSpace?.selected
        @hasSocialPostSpaces = @socialPostSpace?.selected
        @hasNativeIntegrationSpace ||= (space.selected and space.type is "native_integration") for space in @virtualSpaces
        @hasBoothSpaces ||= space.selected for space in @boothSpaces
        @hasMediaSpaces ||= space.selected for space in @mediaSpaces
        @canPlayMedia ||= space.selected for space in @mediaSpaces
        @hasTruckSpaces ||= space.selected for space in @truckSpaces

    watch:
      page: (newVal, oldVal) -> 
        document.getElementById('scrollview')?.scrollTo(0,0)
      showAddOrganizer: (newVal, oldVal) -> @closeAndResetMemberModal() if newVal is false
      hasVirtualSpaces: (val) ->
        if val is false
          for space in @virtualSpaces
            space.selected = false 
            @spaceDeleted(space)
      hasBoothSpaces: (val) ->
        if val is false
          for space in @boothSpaces
            space.selected = false 
            @spaceDeleted(space)
      hasTruckSpaces: (val) ->
        if val is false
          for space in @truckSpaces
            space.selected = false 
            @spaceDeleted(space)
      hasMediaSpaces: (val) ->
        if val is false
          for space in @mediaSpaces
            space.selected = false 
            @spaceDeleted(space)
        else
          for space in @mediaSpaces
            space.selected = true
            @spaceUpdated(space)

      hasSocialPostSpaces: (val) ->
        space = @socialPostSpace
        space.selected = val
        if space.selected 
          @spaceUpdated(space)
        else
          @spaceDeleted(space)

      hasProductSamplingSpaces: (val) ->
        space = @productSamplingSpace
        space.selected = val
        if space.selected 
          @spaceUpdated(space)
        else
          @spaceDeleted(space)

      hasStorage: (val) ->
        if val
          @eventWizard.restrictions.onsite.storage_available = true
        else
          @eventWizard.restrictions.onsite.storage_available = false
          @eventWizard.restrictions.onsite.climate_controlled_storage_available = false
          @eventWizard.restrictions.onsite.cold_storage_available = false
          @eventWizard.restrictions.onsite.frozen_storage_available = false

      eventWizard: (newVal, oldVal) ->
        @frozenEvent = JSON.parse(JSON.stringify(@eventWizard))
        @initializeWizard() unless oldVal?
        @updateWizard() if oldVal?
        return unless newVal? and oldVal?
        if newVal.published and !oldVal.published
          @showEnhancementModal = true
export default VueOptions.vue settings
